<ng-container *ngIf="formGroup && step">
    <ng-container [ngSwitch]="form.settings?.form">

        <h2 *ngSwitchCase="'Customer Info'">Please Add Buyer information</h2>
        <app-forms-customer-info
            *ngSwitchCase="'Customer Info'"
            [formGroup]="formGroup">
        </app-forms-customer-info>

        <h2 *ngSwitchCase="'Vehicle Select'">Please Select Vehicle</h2>
        <app-forms-vehicle-select
            *ngSwitchCase="'Vehicle Select'"
            [makeControl]="control('make_id')"
            [modelControl]="control('model_id')"
            [trimControl]="control('trim_id')"
            [filters]="vehicleSelectMakes"
        ></app-forms-vehicle-select>

        <div *ngSwitchDefault>Form was not Found.</div>
    </ng-container>
</ng-container>
